import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ROOT_DIR, LOCATION } from '../../utils/Constants';
import NotFoundLink from '../pieces/NotFoundLink';
import GoogleAd from '../pieces/GoogleAd';

const style = {
  display: 'block'
}

class ListItems extends Component {
  
  render(){
    /* props:
    list (array)
    typeDir (string)
    */
    let list = this.props.list;
    let typeDir = this.props.typeDir;
    return(
      <div className="results">
        <ul className="results-list">
        <li>
        <GoogleAd 
          client="ca-pub-3501112787403549" 
          slot="9802299641" 
          format="auto" 
          wrapperDivStyle={style}
        />
        </li>
          { list.map((item, idx) => (
            item.vicinity.indexOf(LOCATION) > -1 &&
            <li key={idx}>
              
              <h3 className="results-title no-margin"><Link to={`/details/${typeDir}/${item.place_id}`}>{item.name}</Link></h3>
              
              {item.opening_hours && item.opening_hours.open_now ? 
              
                <img className="open-icon" src={`${ROOT_DIR}/assets/img/open.png`} alt=""/>
              :
              ''
              }
              
              <p>{item.vicinity}</p>
            </li>
          ))
          }
          
        </ul>
        <NotFoundLink/>
      </div>
    );
  }
}
export default ListItems;


// WEBPACK FOOTER //
// ./src/components/blocks/ListItems.js